const base = "cui-button-ylou";
const loader = "cui-button-loader-uhaf";
const dot = "cui-button-dot-let3";
const pulse1 = "cui-button-pulse1-wbk7";
const pulse2 = "cui-button-pulse2-afsc";
const pulse3 = "cui-button-pulse3-occc";
const content = "cui-button-content-vmdv";
const s = "cui-button-s-kyyv";
const m = "cui-button-m-p5bj";
const primary = "cui-button-primary-y79g";
const destructive = "cui-button-destructive-os0y";
const secondary = "cui-button-secondary-owsx";
const tertiary = "cui-button-tertiary-s4ao";
const label = "cui-button-label-cmag";
const classes = {
  base,
  loader,
  dot,
  pulse1,
  pulse2,
  pulse3,
  content,
  "leading-icon": "cui-button-leading-icon-krqk",
  "trailing-icon": "cui-button-trailing-icon-mv83",
  s,
  m,
  primary,
  destructive,
  secondary,
  tertiary,
  label
};
export {
  base,
  content,
  classes as default,
  destructive,
  dot,
  label,
  loader,
  m,
  primary,
  pulse1,
  pulse2,
  pulse3,
  s,
  secondary,
  tertiary
};
